module.exports = __webpack_public_path__ + "img/LDSJ_STILL8.89583b95.jpg";